import styled, { css } from 'styled-components'
import { InputHTMLAttributes } from 'react'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
interface IStylesProps {
  value: number
  min: number
  max: number
}

const _setFilledLeftPercentage = (props: IStylesProps) => {
  const value = ((props.value - props.min) / (props.max - props.min)) * 100
  if (value >= 0 && value <= 100) {
    return `${value}%`
  }
  return 'auto'
}

const thumbStyles = css`
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  background: ${COLORS.surface};
  cursor: pointer;
  border-radius: 50%;
  z-index: 2;
  border: 1px solid ${COLORS.borderHover} !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  top: 50%;
  position: absolute;
  left: var(--filledLeftPercentage);
  transform: translate(-50%, -50%);
  &:hover {
    transform: translate(-50%, -50%) scale(1.15);
    border-color: ${COLORS.primary} !important;
  }
  @supports (-ms-ime-align: auto) {
    position: initial;
    left: initial;
    transform: translate(0, 0);
    &:hover {
      transform: translate(0, 0) scale(1);
    }
  }
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 18px;
    height: 18px;
  }
`

export const Wrapper = styled.div<{
  $isFullWidth: boolean
}>`
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : '135px')};
  padding-inline-start: ${({ $isFullWidth }) => ($isFullWidth ? '0' : '7px')};
  flex: ${({ $isFullWidth }) => $isFullWidth && 1};
`

export const RangeSliderWrapper = styled.div.attrs<IStylesProps>(props => ({
  style: {
    ['--filledLeftPercentage' as string]: _setFilledLeftPercentage(props)
  }
}))<IStylesProps>`
  box-sizing: border-box;
  width: 100%;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%;
    height: 3px;
    background: ${COLORS.secondaryLight};
    border-radius: 6px;
  }
  &::before {
    content: '';
    width: var(--filledLeftPercentage);
    position: absolute;
    box-sizing: border-box;
    align-items: center;
    border-radius: 6px;
    background-color: ${COLORS.primaryDark};
    height: 3px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    left: 0;
  }
`

export const RangeSlider = styled.input.attrs<IStylesProps>(
  (props: IStylesProps & InputHTMLAttributes<HTMLInputElement>) => ({
    style: {
      ['--filledLeftPercentage' as string]: _setFilledLeftPercentage(props),
      ['--thumbColor' as string]: COLORS.primaryDark
    }
  })
)<IStylesProps>`
  position: relative;
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 12px;
  background: transparent;
  outline: none;
  opacity: 0.99;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  z-index: 1;
  margin: 0;
  display: flex;
  &:hover {
    cursor: pointer;
  }
  @supports not (-ms-ime-align: auto) {
    &:hover::after {
      opacity: 0.2;
    }
    &::after {
      position: absolute;
      left: var(--filledLeftPercentage);
      top: 50%;
      transform: translate(-50%, -50%);
      content: '';
      opacity: 0;
      height: 25px;
      width: 25px;
      background: var(--thumbColor);
      border-radius: 50%;
    }
  }

  &::-ms-thumb {
    ${thumbStyles};
  }
  &::-webkit-slider-thumb {
    ${thumbStyles};
  }
  &::-moz-range-thumb {
    ${thumbStyles};
    transform: translate(0, 0);
    &:hover {
      transform: translate(0, 0) scale(1.1);
    }
  }
`
